import React from 'react';
import GenericTableFilter from '../../../../../components/common/GenericTableFilter';

const PreStockInspectionFilter = ({ filterFields, columns, handleSearch, handleApplyFilters, handleResetFilters, customFilterTypes = {}, customFilterOptions = {} }) => {
    return (
        <GenericTableFilter 
            filterFields={filterFields} 
            columns={columns} 
            initialFilters={{}} 
            onSearch={handleSearch} 
            onApplyFilters={handleApplyFilters} 
            onResetFilters={handleResetFilters}
            customFilterTypes={customFilterTypes}
            customFilterOptions={customFilterOptions}
        />
    );
};

export default PreStockInspectionFilter;
